<template>
  <div class="animated fadeIn">
    <b-modal @close="hideModal" @hide="hideModal" ref="modal-hsm" scrollable centered>
      <template #modal-title>
        <i class="fas fa-exclamation-triangle"></i> Selecione a mensagem que será utilizada
      </template>
      <div class="col-md-12">
        <label for="txtGroup">
          <small v-if="form.tipoMensagem.required" class="text-danger">*</small>
          Selecione o tipo de mensagem
        </label>
        <FormulateInput
          v-model="form.tipoMensagem.value"
          type="radio"
          error-behavior="live"
          :options="MessageOptions"
        />
      </div>
      <div class="col-md-12" v-show="form.tipoMensagem.value === 'HOM'">
        <label for="txtGroup">
          <small v-if="form.hsm.required" class="text-danger">*</small>
          HSM:
        </label>
        <div class="input-group">
          <b-form-select v-model="form.hsm.value" :options="form.hsm.options" :state="form.hsm.state" class="mb-3">
            <template slot="first">
              <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
            </template>
          </b-form-select>
        </div>
      </div>
      <div class="col-md-12" v-show="form.tipoMensagem.value === 'NOT_HOM'">
        <label for="txtGroup">
          <small v-if="form.modelo.required" class="text-danger">*</small>
          Modelo:
        </label>
        <div class="input-group">
          <b-form-select v-model="form.modelo.value" :options="form.modelo.options" :state="form.modelo.state" class="mb-3">
            <template slot="first">
              <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
            </template>
          </b-form-select>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 text-right">
          <b-button
            class="btn btn-sm btn-success rounded-4 ml-2"
            size="sm"
            @click.prevent="onSave"
          >
            <i class="fas fa-check-circle"></i><span class="d-md-down-none">&nbsp; Confirmar</span>
          </b-button>
        </div>
      </template>

    </b-modal>
  </div>
</template>

<script>

import HsmRepository from '@/shared/http/repositories/configurations/hsm'
import CampanhaModeloRepository from '@/shared/http/repositories/configurations/templates.js'

import ActionsForm from '@/shared/mixins/actionsForm'
import { loading } from '@/shared/utils/UIHelper'

const hsmData = {
  hsm: null,
  modelo: null
}
const hsmForm = {
  hsm: {
    value: null,
    options: [],
    required: false,
    state: null
  },
  tipoMensagem: {
    value: null,
    options: [],
    required: true,
    state: null
  },
  modelo: {
    value: null,
    options: [],
    required: false,
    state: null
  }
}

export default {
  name: 'HsmModal',
  mixins: [ActionsForm],
  props: {
    attributes: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      form: hsmForm,
      data: hsmData,
      boardColumn: null,
      MessageOptions: {
        'HOM': 'Homologada',
        'NOT_HOM': 'Não Homologada'
      }
    }
  },
  created () {
    this.loadData(this.attributes[0], this.attributes[1])
  },
  mounted () {
    this.$refs['modal-hsm'].show()
  },
  methods: {
    async loadData (index, column) {
      this.boardColumn = column
      this.index = index
      this.onLoadAllHSM()
      this.onLoadAllModelo()
    },
    hideModal (submited) {
      let success = submited === true
      this.$emit('closeModal', success, this.index)
    },
    onSave () {
      this.boardColumn.hsmVinculadoId = this.form.hsm.value ? this.form.hsm.value : null
      this.boardColumn.modeloVinculadoId = this.form.modelo.value ? this.form.modelo.value : null
      this.$parent.boardColumns[this.index] = this.boardColumn
      this.hideModal(true)
    },
    onLoadAllHSM () {
      loading.push()
      this.form.hsm.options = []
      HsmRepository.GetAll()
        .then((response) => {
          if (response.status === 200) {
            let data = response.data.content
            if (data) {
              this.form.hsm.options = response.data.content.map(hsm => {
                return ({ 'text': hsm.hsmName, 'value': hsm.id })
              })
            }
          }
        })
        .catch((err) => {
          this.onException(err)
        })
        .finally(() => {
          loading.pop()
        })
    },
    onLoadAllModelo () {
      CampanhaModeloRepository.GetAll()
        .then((response) => {
          if (response.status === 200) {
            let data = response.data.content
            if (data) {
              this.form.modelo.options = response.data.content.map(modelo => {
                return ({ 'text': modelo.nome, 'value': modelo.id })
              })
            }
          }
        })
        .catch((err) => {
          this.onException(err)
        })
        .finally(() => {
          loading.pop()
        })
    }
  }
}

</script>
<style lang="scss">
.warn{
  &__tittle{
    color: #F00;
    font-size: 1rem;
    font-weight: 600;
  }
  &__subtitle{
    color: #505050;
    font-size: 1rem;
    font-weight: 400;
  }
  hr{
    margin: 1.25rem 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/private/crm/board/modal/hsmModal/HsmModal.vue